<template>
  <v-app-bar app color="indigo darken-2" dark>
    <router-link to="/">
      <img src="@/assets/logoWhite.png" width="100" />
    </router-link>

    <v-toolbar-title>
      <span class="font-weight-light version"> {{ appVersion }}</span>
    </v-toolbar-title>
    <template v-if="getConnected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn rounded icon v-on="on" @click="logoutAndLeave">
            <v-icon>mdi-lock-open-variant-outline</v-icon>
          </v-btn>
        </template>
        <span class="mr-4">Logout</span>
      </v-tooltip>
    </template>
    <template v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn rounded icon v-on="on" @click="loginAndLeave">
            <v-icon>mdi-lock-outline</v-icon>
          </v-btn>
        </template>
        <span class="mr-4">Connexion</span>
      </v-tooltip>
    </template>
    <template v-if="getLogin != ''">
      <span>Logged as {{ getLogin }}</span>
    </template>
    <template v-if="getCurrentSpecies != ''">
      <v-divider class="mx-4" vertical inset></v-divider>
      <router-link :to="'/' + getCurrentSpecies">
        <span style="color:white" class="subheading text-uppercase">
          {{ getCurrentSpeciesLabel }}</span
        >
      </router-link>
    </template>
    <template v-if="getCurrentSpecies !== ''">
      <v-divider class="mx-4" vertical inset></v-divider>
      <v-select
        v-model="selectRelease"
        :items="getAvailableReleaseItems"
        style="max-width:350px"
        hide-details
        @input="goToRelease(selectRelease)"
      ></v-select>
    </template>
    <template v-if="getReferenceNames != ''">
      <v-divider class="mx-4" vertical inset></v-divider>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-for="ref in getReferenceNames" :key="ref" class="subheading" v-on="on">{{
            ref
          }}</span>
        </template>
        <span class="mr-4">Reference genome(s)</span>
      </v-tooltip>
    </template>
    <v-spacer></v-spacer>

    <img src="@/assets/inrae.png" width="100" />
    <img src="@/assets/cnrs2.png" width="50" />
    <img src="@/assets/logo-PLANT2PRO-2020.jpg" width="130" />
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

import { version } from '../../../package';

export default {
  data() {
    return {
      dataselectReleaseItem: '',
      appVersion: version,
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentSpecies',
      'getCurrentSpeciesLabel',
      'getSelectedReleaseId',
      'getSelectedReleaseName',
      'getSelectedReleaseDate',
      'getReferenceNames',
      'getDate',
      'getConnected',
      'getAvailableReleaseItems',
      'getLogin',
      'getSelectedReleaseItem',
    ]),
    selectRelease: {
      get() {
        return this.dataselectReleaseItem === ''
          ? this.getSelectedReleaseId
          : this.dataselectReleaseItem;
      },
      set(val) {
        this.dataselectReleaseItem = val;
      },
    },
  },
  methods: {
    ...mapActions(['login', 'logout', 'loadRelease']),
    goToRelease(r) {
      this.loadRelease(r)
        .then(() => this.$router.push({ path: '/' + this.getCurrentSpecies + '/' + r }))
        .then(() => {
          this.errored = false;
          this.errormsg = 'Error during loading releases';
        });
    },
    loginAndLeave() {
      this.login().then(() => this.$router.push({ path: '/' }));
    },
    logoutAndLeave() {
      this.logout().then(() => this.$router.push({ path: '/' }));
    },
  },
};
</script>

<style scoped>
.version {
  font-size: 12px;
}
</style>
